export { mediatedEventPublish };

const mediatedEventPublish = <TEventPayload>(
	name: string,
	payload?: TEventPayload,
): void => {
	document.dispatchEvent(
		new CustomEvent<TEventPayload>(name, { detail: payload }),
	);
};
